import React from 'react'
import HeaderAbout from '../../component/headerabout/HeaderAbout'
import headerimage from "../../images/header_bg_4.jpg";
import Card from '../../ui/Card'
import { Plan } from "../../data";
import './Plans.css'


function Plans() {
  return (
    <>

      <HeaderAbout title="our Gallery" image={headerimage}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe nihil quibusdam quaerat repudiandae, veritatis quidem.
      </HeaderAbout>

      <section>
        <div className="container plans__container">
          {
            Plan.map(({id, name, desc, price, features}) => {
              return <Card key={id} className='plan-c'>
                <h3>{name}</h3>
                <small>{desc}</small>
                <h1>{`$${price}`}</h1><h2>/EG</h2>
                <h4>features</h4>
                {
                  features.map(({feature, available}, index) =>{
                    return <p key={index} className={!available ? 'disabled' : ''}>{feature}</p>
                  })
                }
                <button className='btn lg'>choose plan</button>
              </Card>
            })
          }
        </div>
      </section>
    </>
  )
}

export default Plans